import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WEB_FONTS, WEB_FONT_BASE_URL, WEB_FONT_SUBSETS, WebFont } from "../constants/web-fonts.constant";

/** Font Family value meaning "use the template's default font". */
export const TEMPLATE_DEFAULT_FONT = "template-default";
const FONT_STYLE_ID = "portal-font-styles";

@Injectable({
  providedIn: 'root'
})
export class FontService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  getNewFontType(name: string): string {
    //Inter v4.0
    return `
    @font-face { font-family:${name}; font-style:normal; font-weight:100; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Thin.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:100; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-ThinItalic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:200; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-ExtraLight.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:200; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-ExtraLightItalic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:300; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Light.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:300; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-LightItalic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:400; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Regular.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:400; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Italic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:500; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Medium.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:500; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-MediumItalic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:600; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-SemiBold.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:600; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-SemiBoldItalic.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:normal; font-weight:700; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-Bold.woff2") format("woff2"); }
    @font-face { font-family:${name}; font-style:italic; font-weight:700; font-display:swap; src:url("https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-BoldItalic.woff2") format("woff2"); }
    
    body {
      font-family: ${name} !important;
    }
    `
  }

  getDefaultFont(name: string): string {
    return `
    /* cyrillic-ext */
    @font-face {
      font-family: ${name};
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-cyrillic-ext.woff2) format('woff2');
      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
    }
    /* cyrillic */
    @font-face {
      font-family: ${name};
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-cyrillic.woff2) format('woff2');
      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
    }
    /* vietnamese */
    @font-face {
      font-family: ${name};
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-vietnamese.woff2) format('woff2');
      unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
    }
    /* latin-ext */
    @font-face {
      font-family: ${name};
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-latin-ext.woff2)  format('woff2');
      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: ${name};
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://prweb-assets-prod.s3.amazonaws.com/fonts/${name}-latin.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }

    body {
        font-family: ${name}, sans-serif !important;
    }
    `;
  }

  /**
   * Cielo's licensed fonts. The @font-face rules live in styles.scss (bundled assets); headings in
   * templates that use sky.heading-font pick up Tiempos through --portal-heading-font.
   */
  getGraphikTiemposFont(): string {
    return `
    :root {
      --portal-heading-font: TiemposHeadline, ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif;
    }

    body {
      font-family: Graphik, ui-sans-serif, system-ui, sans-serif !important;
    }
    `;
  }

  getWebFont(font: WebFont): string {
    const face = (subset: string, unicodeRange: string, weight: number, style: string) => `
    @font-face { font-family:"${font.name}"; font-style:${style}; font-weight:${weight}; font-display:swap; src:url("${WEB_FONT_BASE_URL}/${font.value}/${font.value}-${subset}-${weight}-${style}.woff2") format("woff2"); unicode-range:${unicodeRange}; }`;
    const faces = WEB_FONT_SUBSETS.map(({ subset, unicodeRange }) => [
      ...font.weights.map((weight) => face(subset, unicodeRange, weight, 'normal')),
      face(subset, unicodeRange, 400, 'italic'),
    ].join('')).join('');

    return `${faces}

    body {
      font-family: "${font.name}", ${font.fallback} !important;
    }
    `;
  }

  /**
   * @param templateDefault the template's default font (portal_templates.configuration.defaultFontFamily),
   *   used when the portal's Font Family is "template-default"; Noto Sans when the template has none.
   *   "graphik-tiempos" (Cielo's licensed fonts) is only offered this way, as a template default.
   */
  setFont(name: string, templateDefault?: string): Observable<HTMLStyleElement> {
    name = (name || 'montserrat').toLowerCase();
    if( name === TEMPLATE_DEFAULT_FONT ) {
      name = (templateDefault && templateDefault.toLowerCase() !== TEMPLATE_DEFAULT_FONT)
        ? templateDefault.toLowerCase() : 'noto-sans';
    }
    const webFont = WEB_FONTS.find((font) => font.value === name);
    let styles;
    if( name === 'graphik-tiempos' ) {
      styles = this.getGraphikTiemposFont();
    } else if( webFont ) {
      styles = this.getWebFont(webFont);
    } else if( name === 'inter' ) {
      styles = this.getNewFontType('Inter');
    } else {
      styles = this.getDefaultFont(name);
    }

    // Replace the previous font styles instead of stacking them: when an admin switches fonts, rules from
    // the old font (e.g. --portal-heading-font from graphik-tiempos) must not linger until a reload.
    this.document.getElementById(FONT_STYLE_ID)?.remove();
    const node = this.document.createElement('style');
    node.id = FONT_STYLE_ID;
    node.innerHTML = styles;
    return of(this.document.body.appendChild(node));
  }
}
